// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientManagementHeaderStyles_container__1NUOP","link":"PatientManagementHeaderStyles_link__3O9ph","selected":"PatientManagementHeaderStyles_selected__VuJR3"};